module.exports = __webpack_public_path__ + "static/not-by-ai-5bdaa2eca96707178f549a5cd193033c.svg";